import { Minus, Plus } from "lucide-react";
import type { LimitesDoTamanho } from "./use-editor-da-planta";

export type TamanhoDaPlantaProps = {
  colunas: number;
  linhas: number;
  limites: LimitesDoTamanho;
  onMudar: (colunas: number, linhas: number) => void;
};

const botao =
  "flex h-7 w-7 items-center justify-center rounded-md border border-zinc-200 text-zinc-600 hover:bg-zinc-100 disabled:opacity-40 disabled:hover:bg-transparent dark:border-border dark:text-muted-foreground dark:hover:bg-muted";

/** Largura e altura da planta em quadradinhos; cresce e encolhe pela direita e por baixo. */
export function TamanhoDaPlanta({ colunas, linhas, limites, onMudar }: TamanhoDaPlantaProps) {
  const linha = (rotulo: string, valor: number, l: LimitesDoTamanho["colunas"], mudar: (v: number) => void) => (
    <div className="flex items-center gap-2 px-2">
      <span className="flex-1 text-[13px] text-zinc-700 dark:text-foreground">{rotulo}</span>
      <button type="button" aria-label={`Diminuir ${rotulo.toLowerCase()}`} className={botao} disabled={valor <= l.min} onClick={() => mudar(valor - 1)}>
        <Minus className="h-3.5 w-3.5" />
      </button>
      <span className="w-6 text-center text-sm font-semibold tabular-nums text-zinc-900 dark:text-foreground">{valor}</span>
      <button type="button" aria-label={`Aumentar ${rotulo.toLowerCase()}`} className={botao} disabled={valor >= l.max} onClick={() => mudar(valor + 1)}>
        <Plus className="h-3.5 w-3.5" />
      </button>
    </div>
  );

  const travas = [limites.colunas.travadoPorPeca && "direita", limites.linhas.travadoPorPeca && "de baixo"].filter(Boolean);

  return (
    <div className="space-y-1.5">
      {linha("Largura", colunas, limites.colunas, (v) => onMudar(v, linhas))}
      {linha("Altura", linhas, limites.linhas, (v) => onMudar(colunas, v))}
      {travas.length > 0 && (
        <p className="px-2 text-[11px] leading-snug text-zinc-500 dark:text-muted-foreground">
          Para diminuir, afaste as peças da borda {travas.join(" e da borda ")}.
        </p>
      )}
    </div>
  );
}
